import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

/**
 * Routes that should only redirect to V2 for the base path.
 * Sub-routes (like /contact/details/:id) will stay in V1.
 */
const BASE_PATH_ONLY_REDIRECTS = ['contact', 'article_news', 'deliverable', 'orders', 'events', 'project'];

/**
 * Guard to redirect users to the new domain when they try to access old routes.
 * If newDomainUrl is configured, it will redirect the user to the corresponding
 * page on the new domain instead of allowing access to the old route.
 * 
 * For routes in BASE_PATH_ONLY_REDIRECTS, only the base listing page redirects to V2.
 * Sub-routes (like details pages) remain in V1.
 */
@Injectable({
  providedIn: 'root'
})
export class NewDomainRedirectGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // Check if newDomainUrl is configured
    if (environment.newDomainUrl) {
      const urlPath = state.url.split('?')[0]; // Remove query params
      const urlSegments = urlPath.split('/').filter(segment => segment); // Get path segments
      const basePath = urlSegments[0]; // e.g., 'contact', 'company', etc.
      
      // Check if this route should only redirect on base path
      if (BASE_PATH_ONLY_REDIRECTS.includes(basePath)) {
        // If there are sub-routes (more than just the base path), allow V1 navigation
        if (urlSegments.length > 1) {
          return true;
        }

        // If the URL has open_merge query param, stay in V1
        if (state.url.includes('open_merge=1')) {
          return true;
        }
      }
      
      // Build the full URL for the new domain
      const newUrl = environment.newDomainUrl + state.url;
      
      // Redirect to the new domain
      window.location.href = newUrl;
      
      // Return false to prevent navigation in the current app
      return false;
    }
    
    // If no newDomainUrl is configured, allow normal navigation
    return true;
  }
}

